import React from 'react';
import PropTypes from 'prop-types';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMConst from 'lib/SMConst';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMEditMenuTableRow from 'components/dashboard/form/SMEditMenuTableRow';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import reactMixin from 'react-mixin';

class SMOSpaceEditMenuView extends React.Component {

  componentDidMount() {
    window.addEventListener('resize', this.editViewSizeToFit.bind(this), false);
    this.editViewSizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.editViewSizeToFit.bind(this), false);
  }

  componentDidUpdate(prevProps, prevState) {
    window.addEventListener('resize', this.editViewSizeToFit.bind(this), false);
    this.editViewSizeToFit();
  }
  
  editViewSizeToFit(e) {
    let $navigationTable = $(this.refs.navigationTable),
        $navigationTableFooter = $(this.refs.navigationTableFooter);
        
    $navigationTable.outerHeight(this.navigationTableHeight() - $navigationTableFooter.outerHeight());
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  hiddenButtonDidClick(e) {
    e.preventDefault();

    if (window.confirm(I18n.t("dashboard.notice_000011"))) {
      this.actionButtonDidClick(SMConst.Visibility.Hidden, 'od save hidden_space', e);
    }
  }

  actionButtonDidClick(status, label, e) {
    this.trackPageEvent(label);

    if(this.props.delegate && typeof this.props.delegate.actionButtonDidClick === 'function') {
      this.props.delegate.actionButtonDidClick(status, e);
    }
  }

  renderActionButtons() {

    if (!this.props.space.can_display) {
      return(
        <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
          <p className="dashboard-sidecol__buttonarea-title">公開するのに必要な情報が<br />すべて入力されていません</p>
          <a href={Routes.owner_dashboard_spaces_path(this.props.owner.username)} className="button-gray dashboard-sidecol__buttonarea-button" onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Hidden, 'od temporarily_save space_1')}>終了</a>
        </div>
      );
    }

    let hasRooms = (this.props.space.rooms && this.props.space.rooms.length > 0);
    // 審査前
    if (this.props.owner.status == SMConst.OwnerStatus.Created) {
      // スペースも作成済み
      if (hasRooms) {
        return(
          <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
            <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)}
              onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save space_1')}
              className='button-gray dashboard-sidecol__buttonarea-button'>終了</a>
          </div>
        );
      } else {
        return(
          <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
            <p className="dashboard-sidecol__buttonarea-title message-information">公開するのに必要な情報が<br />すべて入力されました</p>
            <p className="dashboard-sidecol__buttonarea-content">続いてスペースを登録しましょう！</p>
            <a href={Routes.new_owner_dashboard_space_room_path(this.props.owner.username, this.props.space.username)}
              onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od add room')}
              className='button-green dashboard-sidecol__buttonarea-button mb10'>スペースの登録へ</a>
            <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)}
              onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od temporarily_save space_1')}
              className='button-gray dashboard-sidecol__buttonarea-button'>終了</a>
          </div>
        );
      }
    }
    else {
      // スペース作成済み
      if (hasRooms) {
        return(
          <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
            <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)}
              onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od save visible_space_0')}
              className='button-green dashboard-sidecol__buttonarea-button'>公開して終了</a>
            <p className="dashboard-sidecol__buttonarea-help">
              <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className="link-hover-border"
                onClick={this.hiddenButtonDidClick.bind(this)}>非公開として終了</a>
            </p>
          </div>
        );
      }
      else {
        return(
          <div ref="navigationTableFooter" className="dashboard-sidecol__buttonarea-bottom">
            <p className="dashboard-sidecol__buttonarea-title message-information">公開するのに必要な情報が<br />すべて入力されました</p>
            <p className="dashboard-sidecol__buttonarea-content">続いてスペースを登録しましょう！</p>
            <a href={Routes.new_owner_dashboard_space_room_path(this.props.owner.username, this.props.space.username)}
              onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od add room')}
              className='button-green dashboard-sidecol__buttonarea-button mb10'>スペースの登録へ</a>
            <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)}
              onClick={this.actionButtonDidClick.bind(this, SMConst.Visibility.Visible, 'od save visible_space_0')}
              className='button-gray dashboard-sidecol__buttonarea-button'>公開して終了</a>
            <p className="dashboard-sidecol__buttonarea-help">
              <a href={Routes.owner_dashboard_space_path(this.props.owner.username, this.props.space.username)} className="link-hover-border"
                onClick={this.hiddenButtonDidClick.bind(this)}>非公開として終了</a>
            </p>
          </div>
        );
      }
    }
  }

  isCheckedBasic() {
    if (this.props.space.name && this.props.space.name != "" &&
        this.props.space.space_type && this.props.space.space_type != null &&
        this.props.space.description && this.props.space.description != "" &&
        this.props.space.thumbnails && this.props.space.thumbnails.length > 0 &&
        this.props.space.reservable_start && this.props.space.reservable_start != null) {
      return SMConst.AccessoryType.Checked;
    } else {
      return SMConst.AccessoryType.UnMarked;
    }
  }

  isCheckedAddress() {
    if (this.props.space.postal_code && this.props.space.postal_code != "" &&
        this.props.space.state && this.props.space.state != "" &&
        this.props.space.city && this.props.space.city != "" &&
        this.props.space.address_1 && this.props.space.address_1 != "" &&
        this.props.space.tel && this.props.space.tel != "" &&
        this.props.space.access && this.props.space.access != "") {
      return SMConst.AccessoryType.Checked;
    } else {
      return SMConst.AccessoryType.UnMarked;
    }
  }

  render() {
    let navigationTitles = ["基本情報", "住所・アクセス", "定型文", "規約等"],
        navigationRows = [],
        accessoryType = SMConst.AccessoryType.None;

    for (let rowIndex = 0; rowIndex < navigationTitles.length; rowIndex++) {
      let isCurrent = this.props.selectedRowIndex == rowIndex,
          title = navigationTitles[rowIndex];

      if (rowIndex == 0) {
        accessoryType = this.isCheckedBasic();
      } else if (rowIndex == 1) {
        accessoryType = this.isCheckedAddress();
      } else if (rowIndex == 2) {
        accessoryType = SMConst.AccessoryType.Checked;
      } else if (rowIndex == 3) {
        accessoryType = SMConst.AccessoryType.Checked;
      }

      navigationRows.push(<SMEditMenuTableRow key={title}
        title={title} delegate={this.props.delegate} rowIndex={rowIndex} isCurrent={isCurrent} accessoryType={accessoryType} />);
    }

    if (this.props.action == 'new') {
      return(
        <div className="dashboard-sidecol fl">
          <h2 className="dashboard-title mt25 mb25 ml20 mr10">
          {I18n.t("dashboard.label_000090")}
          </h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            <ul>{navigationRows}</ul>
          </div>
          {this.renderActionButtons()}
        </div>
      );
    } else {
      return(
        <div className="dashboard-sidecol fl">
          <h2 className="dashboard-title mt25 mb25 ml20 mr10">
            <img src={this.props.space.cover_photo ? this.props.space.cover_photo : SMRailsBridge.assetPath.noImageSpace} className="dashboard-title__space-img" />
            {I18n.t("dashboard.label_000082")}
            <span className="dashboard-title__space-name">{this.props.space.name}</span>
          </h2>
          <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
            <ul>{navigationRows}</ul>
          </div>
          {this.renderActionButtons()}
        </div>
      );
    }
  }
}
SMOSpaceEditMenuView.propTypes = {
  owner: PropTypes.object.isRequired,
  space: PropTypes.object.isRequired,
  delegate: PropTypes.object.isRequired,
  selectedRowIndex: PropTypes.number.isRequired,
  action: PropTypes.string.isRequired,
};
reactMixin(SMOSpaceEditMenuView.prototype, SMSplitViewMixin);
export default SMOSpaceEditMenuView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/SMOSpaceEditMenuView.jsx